module.exports = __webpack_public_path__ + "img/DemonHunter-bloodelf-m-110.fc6d0267.gif";